import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/supplier_appCommonService";

const initialState = {
  sample_request: {
    data: [],
    status: false,
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
    sampleRequestNr: localStorage.getItem("sample_request_nr") || "",
    workflowSample: null,
  },
  sample_request_detail: {
    data: {},
    status: false,
    sampleRequestNr: localStorage.getItem("sample_request_nr") || "",
  },
};

const sampleSlice = createSlice({
  name: "sample",
  initialState,
  reducers: {
    addSampleRequestNr: (state, action) => {
      state.sample_request.sampleRequestNr = action.payload;
      state.sample_request_detail.sampleRequestNr = action.payload;
      localStorage.setItem("sample_request_nr", action.payload);
    },
    workflowSample: (state, action) => {
      state.sample_request.workflowSample = action.payload;
    },
    clearSampleRequestData: (state) => {
      state.sample_request.data = [];
      state.sample_request.sampleRequestNr = "";
      state.sample_request.workflowSample = null;
      state.sample_request_detail.data = {};
      state.sample_request_detail.sampleRequestNr = "";
      localStorage.removeItem("sample_request_nr");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSampleRequestList.pending, (state) => {
        state.sample_request.status = true;
      })
      .addCase(getSampleRequestList.fulfilled, (state, action) => {
        state.sample_request.status = false;
        state.sample_request.data = action.payload?.data || [];
        state.sample_request.pagination = {
          page: action.payload?.page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
        };
      })
      .addCase(getSampleRequestList.rejected, (state) => {
        state.sample_request.status = false;
      })

      .addCase(getSampleRequestDetail.pending, (state) => {
        state.sample_request_detail.status = true;
      })
      .addCase(getSampleRequestDetail.fulfilled, (state, action) => {
        state.sample_request_detail.status = false;
        const result = action.payload?.data;
        state.sample_request_detail.data = Array.isArray(result) ? result[0] : result || {};
      })
      .addCase(getSampleRequestDetail.rejected, (state) => {
        state.sample_request_detail.status = false;
      });
  },
});

export const { addSampleRequestNr, workflowSample, clearSampleRequestData } = sampleSlice.actions;
export default sampleSlice.reducer;

export const getSampleRequestList = createAsyncThunk(
  "sample/getSampleRequestList",
  async (param) => {
    const payload = {
      queryName: "SampleRequestList",
      page: param?.page || 1,
      per_page: param?.per_page || 10,
      searchTerm: param?.searchTerm || "",
      rowFilter: param?.rowFilter || {},
      ...param,
    };
    const response = await ItemService.generateQuery(payload);
    return response;
  }
);

export const getSampleRequestDetail = createAsyncThunk(
  "sample/getSampleRequestDetail",
  async (param) => {
    const payload = {
      queryName: "SampleRequestDetail",
      sampleRequestNr: param?.sampleRequestNr,
      documentNumber: param?.sampleRequestNr,
      ...param,
    };
    const response = await ItemService.generateQuery(payload);
    return response;
  }
);

